/// <reference path="../../index.d.ts" />

//@ts-ignore
import * as billingpackage from '../../source/js/billingpackage-api';

const billingApi = {
	package: billingpackage as typeof billingpackageApi,
	billingService: {
		client: new billingpackage.BillingServiceClient() as BillingServiceClient,
		fetchTenantAccount: (tenantID: number) => {
			return new Promise<TenantAccount>(resolve => {
				billingApi.billingService.client.getTenantAccount(tenantID, result => {
					resolve(result);
				});
			})
		}
	}
};

export default billingApi;
